import * as React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { __t, applyTranslations } from 'utils/language';

import './audience-data-interests.scss';

import SVGIcon from 'components/svg-icon/SVGIcon';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./audience-data-interests.i18n.json'));

type Props = {
  interests: Array<string>
};

const commonMsgKey = 'collabary_common';
const msgKey = 'audience_data_interests';

const AudienceDataInterests = (
  {
    interests
  }: Props
): JSX.Element => {
  const noData = isEmpty(interests);

  const containerClasses = classnames('audience-data-interests', {
    'audience-data-interests--is-empty': noData
  });

  return (
    <div
      className={containerClasses}
      data-qa="audience-data-interests"
    >
      {
        !noData ?
          interests.map((interest) => (
            <div className="audience-data-interests__row" key={interest}>
              <div className="audience-data-interests__icon">
                <SVGIcon
                  name={interest}
                  isBackgroundContain
                  isBackgroundCenter
                  width={25}
                  height={25}
                />
              </div>
              <div
                className="audience-data-interests__text text-overflow-ellipsis"
                title={__t(`${commonMsgKey}.specialized_in.${interest}`)}
              >
                {__t(`${commonMsgKey}.specialized_in.${interest}`)}
              </div>
            </div>
          )) :
          <div className="audience-data-interests__no-data">
            {__t(`${msgKey}.labels.no_data`)}
          </div>
      }
    </div>
  );
};

export default AudienceDataInterests;
